/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadInfoRequestRace } from './CreateLeadInfoRequestRace';
import {
    CreateLeadInfoRequestRaceFromJSON,
    CreateLeadInfoRequestRaceFromJSONTyped,
    CreateLeadInfoRequestRaceToJSON,
} from './CreateLeadInfoRequestRace';
import type { CreateLeadInfoRequestState } from './CreateLeadInfoRequestState';
import {
    CreateLeadInfoRequestStateFromJSON,
    CreateLeadInfoRequestStateFromJSONTyped,
    CreateLeadInfoRequestStateToJSON,
} from './CreateLeadInfoRequestState';

/**
 * 
 * @export
 * @interface CreateLeadInfoRequest
 */
export interface CreateLeadInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    s3_photo_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    marital_status?: CreateLeadInfoRequestMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    primary_language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    contact_method_preference?: CreateLeadInfoRequestContactMethodPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    current_address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    race_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequest
     */
    religion?: CreateLeadInfoRequestReligionEnum;
    /**
     * 
     * @type {CreateLeadInfoRequestRace}
     * @memberof CreateLeadInfoRequest
     */
    race?: CreateLeadInfoRequestRace;
    /**
     * 
     * @type {CreateLeadInfoRequestState}
     * @memberof CreateLeadInfoRequest
     */
    state?: CreateLeadInfoRequestState;
}


/**
 * @export
 */
export const CreateLeadInfoRequestMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined'
} as const;
export type CreateLeadInfoRequestMaritalStatusEnum = typeof CreateLeadInfoRequestMaritalStatusEnum[keyof typeof CreateLeadInfoRequestMaritalStatusEnum];

/**
 * @export
 */
export const CreateLeadInfoRequestContactMethodPreferenceEnum = {
    Email: 'Email',
    Text: 'Text',
    Call: 'Call',
    Other: 'Other'
} as const;
export type CreateLeadInfoRequestContactMethodPreferenceEnum = typeof CreateLeadInfoRequestContactMethodPreferenceEnum[keyof typeof CreateLeadInfoRequestContactMethodPreferenceEnum];

/**
 * @export
 */
export const CreateLeadInfoRequestReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown'
} as const;
export type CreateLeadInfoRequestReligionEnum = typeof CreateLeadInfoRequestReligionEnum[keyof typeof CreateLeadInfoRequestReligionEnum];


/**
 * Check if a given object implements the CreateLeadInfoRequest interface.
 */
export function instanceOfCreateLeadInfoRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadInfoRequestFromJSON(json: any): CreateLeadInfoRequest {
    return CreateLeadInfoRequestFromJSONTyped(json, false);
}

export function CreateLeadInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'primary_language': !exists(json, 'primary_language') ? undefined : json['primary_language'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'contact_method_preference': !exists(json, 'contact_method_preference') ? undefined : json['contact_method_preference'],
        'current_address': !exists(json, 'current_address') ? undefined : json['current_address'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'race_id': !exists(json, 'race_id') ? undefined : json['race_id'],
        'religion': !exists(json, 'religion') ? undefined : json['religion'],
        'race': !exists(json, 'race') ? undefined : CreateLeadInfoRequestRaceFromJSON(json['race']),
        'state': !exists(json, 'state') ? undefined : CreateLeadInfoRequestStateFromJSON(json['state']),
    };
}

export function CreateLeadInfoRequestToJSON(value?: CreateLeadInfoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        's3_photo_key': value.s3_photo_key,
        'photo_url': value.photo_url,
        'marital_status': value.marital_status,
        'primary_language': value.primary_language,
        'phone_number': value.phone_number,
        'email': value.email,
        'contact_method_preference': value.contact_method_preference,
        'current_address': value.current_address,
        'state_id': value.state_id,
        'race_id': value.race_id,
        'religion': value.religion,
        'race': CreateLeadInfoRequestRaceToJSON(value.race),
        'state': CreateLeadInfoRequestStateToJSON(value.state),
    };
}

